import shouldDoTakedownOrDisable from "../utils/shouldDoTakedownOrDisable";

export default function getEnableDisableArticleChannelTexts({ t, channel, article }) {
	const action = shouldDoTakedownOrDisable({ article, channel });

	switch (action) {
		case "TAKEDOWN":
			return t("takedownAt", "Unpublish");
		case "DISABLE":
			return t("disable", "Disable");
		case "ENABLE":
			return t("enable", "Enable");
		default:
			return "";
	}
}
